(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepwhisper-parent-story-video"] && !Shopify.designMode) return;
  try {
    
  class ParentStoryVideo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.video = this.querySelector('.sw-parent-video__media');
      this.toggle = this.querySelector('[data-parent-video-toggle]');
      this.toggleLabel = this.querySelector('[data-parent-video-toggle-label]');

      if (!this.video || !this.toggle) return;

      this.handleToggle = this.handleToggle.bind(this);
      this.syncState = this.syncState.bind(this);
      this.pauseWhenHidden = this.pauseWhenHidden.bind(this);

      this.toggle.addEventListener('click', this.handleToggle);
      this.video.addEventListener('play', this.syncState);
      this.video.addEventListener('pause', this.syncState);
      this.video.addEventListener('ended', this.syncState);
      document.addEventListener('visibilitychange', this.pauseWhenHidden);

      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.25) this.video.pause();
        },
        { threshold: [0, 0.25] }
      );
      this.intersectionObserver.observe(this);
      this.syncState();
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.handleToggle);
      this.video?.removeEventListener('play', this.syncState);
      this.video?.removeEventListener('pause', this.syncState);
      this.video?.removeEventListener('ended', this.syncState);
      document.removeEventListener('visibilitychange', this.pauseWhenHidden);
      this.intersectionObserver?.disconnect();
    }

    async handleToggle() {
      if (this.video.paused || this.video.ended) {
        if (this.video.ended) this.video.currentTime = 0;

        try {
          await this.video.play();
        } catch (error) {
          this.syncState();
        }
      } else {
        this.video.pause();
      }
    }

    syncState() {
      const isPaused = this.video.paused || this.video.ended;
      this.toggle.dataset.state = isPaused ? 'paused' : 'playing';
      this.toggle.setAttribute('aria-label', isPaused ? "Play Emma's story" : "Pause Emma's story");
      this.toggleLabel.textContent = isPaused ? 'Play video' : 'Pause video';
    }

    pauseWhenHidden() {
      if (document.hidden) this.video.pause();
    }
  }

  if (!customElements.get('parent-story-video')) {
    customElements.define('parent-story-video', ParentStoryVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
